var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15049",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "undo_icon",
    d: "M21.973 18.608v-.116A13.051 13.051 0 009.527 9.306V5.592a.594.594 0 00-1.012-.419l-6.171 6.112a1.164 1.164 0 000 1.653l6.17 6.112a.594.594 0 001-.407v-3.737h1.166a13.062 13.062 0 019.72 4.435.9.9 0 00.722.407.885.885 0 00.878-.872.687.687 0 00-.027-.268z"
  })));
}
export default SvgUndoIcon;